import {combineEpics} from 'redux-observable';
import values from 'lodash/fp/values';
import {epics as privacyPolicy} from '../components/privacy-policy/state';

export default combineEpics(...values(privacyPolicy));
